import { createAction } from 'redux-actions';

export const updateCustomFieldsUserRequest = createAction('UPDATE_CUSTOM_FIELDS_USER_REQUEST');
export const updateCustomFieldsUserSuccess = createAction('UPDATE_CUSTOM_FIELDS_USER_SUCCESS');
export const updateCustomFieldsUserFail = createAction('UPDATE_CUSTOM_FIELDS_USER_FAIL');
